import { createAction } from 'redux-actions';
import { callApi, getEndpoint } from '../../../../utils/api';
const IRA_LIMIT_SEARCH = 'IRA_LIMIT_SEARCH';

const defaultState = {
  isLoading: false,
  isLoaded: false,
  hasFailed: false,
  error: null,
  data: {},
};
export default function (state = {}, { payload, type, meta }) {
  switch (type) {
    case `${IRA_LIMIT_SEARCH}_PENDING`:
      return {
        ...state,
        [meta.bpid]: {
          ...defaultState,
          isLoading: true,
        },
      };
    case `${IRA_LIMIT_SEARCH}_FULFILLED`:
      return {
        ...state,
        [meta.bpid]: {
          ...defaultState,
          isLoading: false,
          isLoaded: true,
          data: payload.body,
        },
      };
    case `${IRA_LIMIT_SEARCH}_REJECTED`:
      return {
        ...state,
        [meta.bpid]: {
          ...defaultState,
          isLoading: false,
          isLoaded: false,
          hasFailed: true,
        },
      };
    default:
      return state;
  }
}

export const getPOAIraLimit = (bpid) => {
  return (dispatch) => {
    const action = createAction(
      IRA_LIMIT_SEARCH,
      (data) => data,
      () => ({ bpid })
    )(callApi(`${getEndpoint('IRALimitSearch')}?bpid=${bpid}`));
    dispatch(action);
  };
};
